import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface MemoryArtefact {
  id: string;
  storage_path: string;
  position: number;
  is_primary: boolean;
  taken_at: string | null;
  caption: string | null;
  mime_type: string | null;
}

export function useMemoryArtefacts(memoryId: string | null) {
  const query = useQuery({
    queryKey: ["memory-artefacts", memoryId],
    enabled: !!memoryId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("memory_artefacts")
        .select("id, storage_path, position, is_primary, taken_at, caption, mime_type")
        .eq("memory_id", memoryId!)
        .order("position", { ascending: true });
      if (error) throw error;
      return (data ?? []) as MemoryArtefact[];
    },
  });

  return {
    data: query.data,
    artefacts: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
